import { render, staticRenderFns } from "./GammaRayShieldingViz.vue?vue&type=template&id=02b208f0&scoped=true"
import script from "./GammaRayShieldingViz.vue?vue&type=script&lang=js"
export * from "./GammaRayShieldingViz.vue?vue&type=script&lang=js"
import style0 from "./GammaRayShieldingViz.vue?vue&type=style&index=0&id=02b208f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b208f0",
  null
  
)

export default component.exports